import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "../css/UnitList.css";

const BedList = () => {
  const navigate = useNavigate();
  const [beds, setBeds] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [toast, setToast] = useState({ show: false, message: "", type: "" });
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [bedToDelete, setBedToDelete] = useState(null);
  const API_URL = process.env.REACT_APP_API_URL || "";

  useEffect(() => {
    const apiUrl = `${API_URL}bed-no-list.php`;
    fetch(apiUrl)
      .then((res) => res.json())
      .then((response) => {
        if (response.status === "success" && Array.isArray(response.data)) {
          setBeds(response.data);
        } else {
          showToast("Failed to load bed list", "error");
        }
      })
      .catch(() => showToast("Error fetching data from the server", "error"));
  }, [API_URL]);

  const showToast = (message, type = "success") => {
    setToast({ show: true, message, type });
    setTimeout(() => {
      setToast({ show: false, message: "", type: "" });
    }, 3000);
  };

  const filteredBeds = beds.filter((bed) => {
    const term = searchTerm.toLowerCase();
    return (
      bed.room_no.toLowerCase().includes(term) ||
      bed.bed_no.toLowerCase().includes(term)
    );
  });

  const handleEdit = (bed) => {
    navigate("/add-bed", { state: { bed } });
  };

  const handleDelete = (bedId) => {
    const bed = beds.find((b) => b.id === bedId);
    setBedToDelete(bed);
    setShowDeleteModal(true);
  };

  const confirmDelete = async () => {
    if (!bedToDelete) return;
    try {
      const response = await fetch(`${API_URL}bed-no-delete.php`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ id: bedToDelete.id }),
      });
      const data = await response.json();
      if (data.status === "success") {
        showToast("Bed deleted successfully", "success");
        setBeds((prevBeds) => prevBeds.filter((bed) => bed.id !== bedToDelete.id));
      } else {
        showToast(data.message || "Failed to delete bed", "error");
      }
    } catch (error) {
      showToast("Network error. Could not delete bed.", "error");
    }
    setShowDeleteModal(false);
    setBedToDelete(null);
  };

  const cancelDelete = () => {
    setShowDeleteModal(false);
    setBedToDelete(null);
  };

  const handleAddBed = () => {
    navigate("/add-bed");
  };

  return (
    <div className="category-list-content">
      <div className="page-header">
        <div className="header-content">
          <h1>Bed Management</h1>
          <p>Manage all beds within rooms</p>
        </div>
        <button className="add-unit-button" onClick={handleAddBed}>
          + Add New Bed
        </button>
      </div>

      <div className="filters-section">
        <div className="search-box">
          <input
            type="text"
            placeholder="Search by room or bed number..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
      </div>

      <div className="unit-list-table-container">
        <table className="unit-list-table">
          <thead>
            <tr>
              <th>Room Number</th>
              <th>Bed Number</th>
              <th>Created At</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {filteredBeds.map((bed) => (
              <tr key={bed.id}>
                <td>
                  <div className="unit-info">
                    <div className="unit-icon">🚪</div>
                    <span>{bed.room_no}</span>
                  </div>
                </td>
                <td>
                  <div className="unit-info">
                    <div className="unit-icon">🛏️</div>
                    <span>{bed.bed_no}</span>
                  </div>
                </td>
                <td>{new Date(bed.created_at).toLocaleString()}</td>
                <td>
                  <div className="action-buttons">
                    <button
                      className="action-btn edit"
                      onClick={() => handleEdit(bed)}
                    >
                      Edit
                    </button>
                    <button
                      className="action-btn delete"
                      onClick={() => handleDelete(bed.id)}
                    >
                      Delete
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="table-footer">
        <div className="results-info">
          Showing {filteredBeds.length} of {beds.length} beds
        </div>
      </div>

      {toast.show && (
        <div className={`toast toast-${toast.type}`}>
          <div className="toast-content">
            <span className="toast-message">{toast.message}</span>
            <button
              className="toast-close"
              onClick={() => setToast({ show: false, message: "", type: "" })}
            >
              ×
            </button>
          </div>
        </div>
      )}

      {showDeleteModal && bedToDelete && (
        <div className="modal-overlay">
          <div className="modal">
            <h3>Confirm Delete</h3>
            <p>
              Are you sure you want to delete Bed <b>{bedToDelete.bed_no}</b> in Room <b>{bedToDelete.room_no}</b>?
            </p>
            <div className="modal-actions">
              <button className="modal-btn yes" onClick={confirmDelete}>Yes</button>
              <button className="modal-btn no" onClick={cancelDelete}>No</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default BedList;
